<template>
<div class="works">
  <header>
    <Header/>
  </header>
  <main>
    <WorksList/>
  </main>
  <footer class="font-color">
    <Footer/>
  </footer>
</div>
</template>
<script>
import Header from '../components/common/Header.vue'
import Footer from '../components/common/Footer'
import WorksList from '../components/works/WorksList.vue'

export default {
  name: 'works',
  components: {
    Header,
    Footer,
    WorksList
  }
}
</script>
<style lang="scss" scoped>
.works {
  position: relative;
  background-color: #000000;
  // width: 100%;
  // height: 100%;
  min-height: 100vh;
  z-index: 1;
}
.font-color {
  color: #ffffff;
}
</style>